import { Route, Routes } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { SessionProvider } from './context/SessionContext';
import { AiConnections } from './pages/AiConnections';
import { AboutPage } from './pages/AboutPage';
import { Channel } from './pages/Channel';
import { CheckoutPage } from './pages/CheckoutPage';
import { ConnectPage } from './pages/ConnectPage';
import { WorldsPage } from './pages/WorldsPage';
import { DesignSystemPage } from './pages/DesignSystemPage';
import { DiscoveryPage } from './pages/DiscoveryPage';
import { EarnPage } from './pages/EarnPage';
import { KeyraCallback } from './pages/KeyraCallback';
import { LibraryPage } from './pages/LibraryPage';
import { Profile } from './pages/Profile';
import { PublishPage } from './pages/PublishPage';
import { RefinePage } from './pages/RefinePage';
import { SearchPage } from './pages/SearchPage';
import { SpinPage } from './pages/SpinPage';
import { StudioPage } from './pages/StudioPage';
import { WorkspacePage } from './pages/WorkspacePage';
import { UploadPage } from './pages/UploadPage';

export function App() {
  return (
    <SessionProvider>
      <div className="app">
        <Header />
        <Routes>
          <Route path="/" element={<DiscoveryPage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/spin/:assetId" element={<SpinPage />} />
          <Route path="/create" element={<WorkspacePage />} />
          <Route path="/workspace" element={<WorkspacePage />} />
          <Route path="/upload" element={<UploadPage />} />
          <Route path="/library" element={<LibraryPage />} />
          <Route path="/connect" element={<ConnectPage />} />
          <Route path="/worlds" element={<WorldsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/earn" element={<EarnPage />} />
          <Route path="/design-system" element={<DesignSystemPage />} />
          <Route path="/studio/:projectId?" element={<StudioPage />} />
          <Route path="/refine/:assetId" element={<RefinePage />} />
          <Route path="/publish/:assetId" element={<PublishPage />} />
          <Route path="/checkout/:listingId" element={<CheckoutPage />} />
          <Route path="/settings/ai" element={<AiConnections />} />
          <Route path="/auth/keyra/callback" element={<KeyraCallback />} />
          <Route path="/channel/:username" element={<Channel />} />
          <Route path="/profile" element={<Profile />} />
        </Routes>
        <Footer />
      </div>
    </SessionProvider>
  );
}
